const checkIsMobileScreen = (): boolean => window.innerWidth <= 768

const mobileScreenState = {
  isMobileScreen: checkIsMobileScreen(),
}

const getters = {
  isMobileScreen: (state: typeof mobileScreenState) => state.isMobileScreen,
}

const mutations = {
  UPDATE_IS_MOBILE_SCREEN(state: typeof mobileScreenState) {
    state.isMobileScreen = checkIsMobileScreen()
  },
}

const actions = {
  updateIsMobileScreen({ commit }: any) {
    commit('UPDATE_IS_MOBILE_SCREEN')
  },
}

export default {
  state: mobileScreenState,
  getters,
  mutations,
  actions,
}
